import { jsx as t, jsxs as N } from "react/jsx-runtime";
import { useState as b, useRef as I, useMemo as v } from "react";
import { c } from "../../index-C7ezJk5b.js";
import { b as P, S as U } from "../../base-BUIxijjU.js";
import A from "../../core/hooks/useOutsideClick.js";
import { cssTI as o, cssX as r } from "../../core/utils/css.js";
import S from "../../components/Dropdown/Dropdown.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const u = ({
  href: a,
  className: e,
  testId: i,
  children: n,
  ...l
}) => /* @__PURE__ */ t(
  "a",
  {
    href: a,
    className: c(r("Dropdown__item"), "is-tall", e),
    "data-testid": i,
    ...l,
    children: n
  }
), R = () => {
  const [a, e] = b(!1), i = I(null), n = P(), {
    userInfo: {
      initials: l,
      snapMyDocsUrl: p,
      snapTeamsUrl: f,
      logOutLink: h,
      snapAdmin: d
    },
    additionalUserMenu: g
  } = n;
  A({
    ref: i,
    callback: () => e(!1)
  });
  const M = v(
    () => {
      const s = [];
      s.push({
        id: "snap-my-docs",
        content: /* @__PURE__ */ t(
          u,
          {
            href: U.getSnapInternalUrl(p, n),
            testId: o("button", "PlatformNavigationUserMenuMyDocs"),
            children: "My Docs"
          }
        )
      }), s.push({
        id: "snap-teams",
        content: /* @__PURE__ */ t(
          u,
          {
            href: U.getSnapInternalUrl(f, n),
            testId: o("button", "PlatformNavigationUserMenuTeams"),
            children: "Teams"
          }
        )
      }), d && s.push({
        id: "snap-admin",
        content: /* @__PURE__ */ t(
          u,
          {
            href: d.url,
            testId: o("button", "PlatformNavigationUserMenuSnapAdmin"),
            target: "_blank",
            children: "SNAP Admin"
          }
        )
      }), s.push({
        id: "log-out",
        content: /* @__PURE__ */ t(
          u,
          {
            href: h,
            testId: o("button", "PlatformNavigationUserMenuLogOut"),
            children: "Log Out"
          }
        )
      });
      const m = [];
      return g.length > 0 && m.push({
        id: "additional-items",
        items: g,
        hasSeparator: !0
      }), m.push({
        id: "user-actions",
        items: s
      }), m;
    },
    [p, f, h, d, n]
  );
  return /* @__PURE__ */ N(
    "div",
    {
      ref: i,
      className: c(r("PlatformNavigation__button")),
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: c(r("PlatformNavigation__button-inner")),
            "data-tooltip-id": r("user-actions-dropdown"),
            onMouseEnter: () => e(!0),
            onClick: () => e(!a),
            "data-testid": o("button", "PlatformNavigationUserMenu"),
            children: l
          }
        ),
        /* @__PURE__ */ t(
          S,
          {
            id: r("user-actions-dropdown"),
            groups: M,
            isOpened: a,
            onClick: () => e(!1)
          }
        )
      ]
    }
  );
};
export {
  R as default
};
